import { PwaManifestChecker }  from "./custom-elements/pwa-manifest-checker.js"
import { PwaManifestContents } from "./custom-elements/pwa-manifest-contents.js"
import { PwaMainNav }          from "./custom-elements/pwa-main-nav.js"
import { PwaLabelWithTooltip } from "./custom-elements/pwa-label-with-tooltip.js"

customElements.define(PwaManifestContents.tagName, PwaManifestContents)
customElements.define(PwaManifestChecker.tagName,  PwaManifestChecker)
customElements.define(PwaMainNav.tagName,          PwaMainNav)
customElements.define(PwaLabelWithTooltip.tagName, PwaLabelWithTooltip)
